import React, { useState } from "react";
import jwtDecode from "jwt-decode";

function ReviewdReportDetails({ selectedReport, adminName }) {
  const date = new Date(selectedReport?.date);
  const formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  const combinedMedia = [
    ...(selectedReport?.photos || []),
    ...(selectedReport?.videos || []),
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [zoomedImage, setZoomedImage] = useState(null);

  // const isVideo = (media) =>
  //   media.endsWith(".mp4") || media.endsWith(".avi") || media.endsWith(".mov");

    const isVideo = (media) => {
  if (!media || typeof media !== "string") return false; // ✅ guard
  const lower = media.split("?")[0].toLowerCase();      // remove query params
  return lower.endsWith(".mp4") || lower.endsWith(".avi") || lower.endsWith(".mov");
};

  // ✅ Decode role from JWT
  let role = null;
  const rawToken = localStorage.getItem("token")?.replace(/"/g, "");
  if (rawToken) {
    try {
      const decoded = jwtDecode(rawToken);
      role =
        decoded.role ||
        decoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ];
    } catch (err) {
      console.error("Failed to decode token", err);
    }
  }

  // 🔹 Carousel navigation
  const prevSlide = () => {
    const newIndex =
      (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
  };

  // 🔹 Fullscreen navigation
  const prevZoomed = () => {
    const newIndex =
      (currentIndex - 1 + combinedMedia.length) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  const nextZoomed = () => {
    const newIndex = (currentIndex + 1) % combinedMedia.length;
    setCurrentIndex(newIndex);
    if (!isVideo(combinedMedia[newIndex])) {
      setZoomedImage(combinedMedia[newIndex]);
    }
  };

  // // 🔹 Determine reviewer name for watermark
  // const reviewerName =
  //   role === "admin_police" || role === "assistant_police"
  //     ? selectedReport?.policeReviewer
  //     : selectedReport?.adminName;

  return (
    <>
      <input type="checkbox" id="my-modal-5" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl rounded-2xl bg-white p-6 shadow-xl">
          {/* Header */}
          <div className="mb-4 flex items-center justify-between">
            <h3 className="w-full text-center text-lg font-bold text-brand-500">
              Detajet e raportit #{selectedReport?.reportName}
            </h3>
            <label
              htmlFor="my-modal-5"
              className="btn btn-circle btn-sm bg-white text-brand-700 hover:text-white"
              onClick={() => setZoomedImage(null)}
            >
              ✕
            </label>
          </div>
          <hr />

          {/* Report Info */}
          <div className="mt-4 space-y-3">
            <p>
              <span className="font-bold">Qyteti:</span>{" "}
              {selectedReport?.address
                ? (() => {
                    const gpsMatch =
                      selectedReport.address.match(/\(([^)]+)\)/);
                    const cityName = selectedReport.address
                      .split("(")[0]
                      .trim();

                    if (gpsMatch && gpsMatch[1]) {
                      const [lat, lng] = gpsMatch[1]
                        .split(",")
                        .map((x) => x.trim());
                      const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

                      return (
                        <>
                          <span>{cityName} </span>
                          <span>(</span>
                          <a
                            href={googleMapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer font-semibold text-blue-600 underline"
                            title="Shiko lokacionin në Google Maps"
                          >
                            {lat}, {lng}
                          </a>
                          <span>)</span>
                        </>
                      );
                    }
                    return <span>{selectedReport.address}</span>;
                  })()
                : "Unknown"}
            </p>

            <p>
              <span className="font-bold">Kategoria:</span>{" "}
              {selectedReport?.category}
            </p>

            {(role === "admin_police" || role === "assistant_police") &&
              selectedReport?.lawName &&
              selectedReport.lawName.trim() !== "" && (
                <p>
                  <span className="font-bold">Ligji:</span>{" "}
                  {selectedReport.lawName}
                </p>
              )}

            <p>
              <span className="font-bold">Data e raportimit:</span>{" "}
              {formattedDate}
            </p>
            <p className="break-words">
              <span className="font-bold">Përshkrimi:</span>{" "}
              {selectedReport?.context || "N/A"}
            </p>
            {/* {(role === "admin" || role === "admin_assistant") &&
              selectedReport?.licensePlate &&
              selectedReport.licensePlate.trim() !== "" && (
                <p>
                  <span className="font-bold">Targat e veturës:</span>{" "}
                  {selectedReport.licensePlate}
                </p>
              )} */}
          </div>

          {/* Media Carousel */}
          {combinedMedia.length > 0 && (
            <div className="relative mx-auto mt-6 flex max-w-2xl items-center justify-center">
              <div className="relative">
                {isVideo(combinedMedia[currentIndex]) ? (
                  <video
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full rounded-lg object-contain shadow"
                    controls
                  />
                ) : (
                  <img
                    src={combinedMedia[currentIndex]}
                    className="max-h-80 w-auto max-w-full cursor-pointer rounded-lg object-contain shadow transition hover:scale-105"
                    alt={`media-${currentIndex + 1}`}
                    onClick={() => setZoomedImage(combinedMedia[currentIndex])}
                  />
                )}

                {/* ✅ Watermark */}
                {adminName?.trim() && (
                  <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
                    <span
                      className="font-bold text-white/30 break-words text-center"
                      style={{
                        transform: "rotate(-45deg)",
                        userSelect: "none",
                        width: "90%",
                        fontSize: "clamp(14px, 4vw, 40px)",
                        lineHeight: "1.1",
                      }}
                    >
                      {adminName}
                    </span>
                  </div>
                )}
              </div>

              {combinedMedia.length > 1 && (
                <>
                  <button
                    onClick={prevSlide}
                    className="btn btn-circle absolute left-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❮
                  </button>
                  <button
                    onClick={nextSlide}
                    className="btn btn-circle absolute right-2 bg-white text-brand-700 shadow-md hover:text-white"
                  >
                    ❯
                  </button>
                </>
              )}
            </div>
          )}

          <hr className="my-4" />

          {/* Status */}
          <div className="mb-4 flex items-center">
            <p className="text-lg font-bold dark:text-white">Statusi:</p>
            <p className="ml-2 text-lg">
              {selectedReport?.isApproved === "PO"
                ? "Aprovuar"
                : selectedReport?.isApproved === "JO"
                ? "Refuzuar"
                : "Në pritje"}
            </p>
          </div>

          {/* Footer */}
          <footer className="modal-action mt-6 flex justify-end gap-2">
            <label
              htmlFor="my-modal-5"
              className="btn border-0 bg-brand-500 text-white hover:bg-brand-700"
            >
              Mbyll
            </label>
          </footer>
        </div>
      </div>

      {/* Fullscreen Image Viewer */}
      {zoomedImage && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90">
          <button
            className="absolute right-4 top-4 text-3xl text-white"
            onClick={() => setZoomedImage(null)}
          >
            ✕
          </button>
          {combinedMedia.length > 1 && (
            <>
              <button
                onClick={prevZoomed}
                className="absolute left-5 text-4xl text-white"
              >
                ❮
              </button>
              <button
                onClick={nextZoomed}
                className="absolute right-5 text-4xl text-white"
              >
                ❯
              </button>
            </>
          )}
          <div className="relative">
            <img
              src={zoomedImage}
              className="max-h-full max-w-full rounded-lg object-contain transition-transform duration-200 hover:scale-110"
              alt="Zoomed Media"
            />
            {adminName?.trim() && (
              <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
                <span
                  className="font-bold text-white/30 break-words text-center"
                  style={{
                    transform: "rotate(-45deg)",
                    userSelect: "none",
                    width: "90%",
                    fontSize: "clamp(14px, 4vw, 40px)",
                    lineHeight: "1.1",
                  }}
                >
                  {adminName}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default ReviewdReportDetails;
